











































import { PropType } from 'vue';
import { IAiStream } from '../types';
import { fmtTime } from '../utils';
import formatDate from '@/helpers/formatDate';
import { COLOR_DETAIL_FALLBACK } from '../constants';
import LangChip from './LangChip.vue';
import { EAiStreamerStatus } from '@/views/CopyStake/CopyStakeAiStreamer/types';

export default {
  name: 'StreamDetailDialog',
  components: { LangChip },
  props: {
    value: { type: Boolean, default: false },
    stream: {
      type: Object as PropType<IAiStream | null>,
      default: null
    },
    color: { type: String, default: COLOR_DETAIL_FALLBACK },
    timeZone: { type: String, default: 'UTC' }
  },
  computed: {
    formattedDate(): string {
      if (!this.stream) return '';
      return formatDate(
        this.stream.startTime || '',
        'EEEE, MMMM d',
        false,
        false
      );
    },
    isInSchedule(): boolean {
      return this.stream.status === EAiStreamerStatus.SCHEDULED;
    },
    detailRows(): { label: string; value: unknown }[] {
      const s = this.stream;
      if (!s) return [];
      const rows: { label: string; value: unknown }[] = [
        {
          label: 'Games',
          value: s.supportedGames.map(({ name }) => name).join(', ')
        },
        {
          label: `Time (${this.timeZone})`,
          value: `${fmtTime(s.startTime)}-${fmtTime(s.endTime)}`
        },
        { label: 'Date', value: this.formattedDate },
        { label: 'Language', value: s.voiceLanguage },
        { label: 'Status', value: s.status },
        { label: 'Streamer ID', value: s.streamerId }
      ];
      return rows.filter(
        (r: { label: string; value: unknown }) =>
          r.value !== undefined && r.value !== null && r.value !== ''
      );
    }
  }
};
